import React, { useEffect, useState } from "react";

const SelectedDays = ({ selectedDays, setSelectedDays, availableDays, firstDay }) => {
  const [sortedDays, setSortedDays] = useState([]);

  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  const onDaySelected = (day) => {
    if (selectedDays.includes(day)) {
      setSelectedDays(selectedDays.filter((selectedDay) => selectedDay !== day));
    } else {
      setSelectedDays([...selectedDays, day]);
    }
  };

  useEffect(() => {
    const firstDayIndex = days.indexOf(firstDay);
    setSortedDays([...days.slice(firstDayIndex), ...days.slice(0, firstDayIndex)]);
  }, [firstDay]);

  return (
    <div className="flex gap-2">
      {sortedDays.map((day) => (
        <DayBullet
          key={day}
          day={day}
          isAvailable={availableDays.includes(day)}
          isSelected={selectedDays.includes(day)}
          onClick={() => onDaySelected(day)}
        />
      ))}
    </div>
  );
};

const DayBullet = ({ day, isSelected, onClick, isAvailable }) => {
  const onDaySelected = () => {
    if (!isAvailable) {
      return;
    }
    onClick();
  };

  return (
    <div
      className={`size-[24px] md:size-[30px] rounded-full md:hover:opacity-80 
      ${ isSelected ? "bg-ov-green text-white font-semibold" : 
      isAvailable ? "bg-slate-200" : "pointer-events-none bg-slate-200 text-gray-400"}
      flex items-center justify-center cursor-pointer`}
      onClick={onDaySelected}
    >
      <span className="text-[12px] md:text-[14px]">{day[0]}</span>
    </div>
  );
};

export default SelectedDays;
